import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { AttachmentItem } from './attachment-item';
import { ExpertiseAttachmentResponse } from '../../../../store/details/expertise-attachment/model';
import { connect } from 'react-redux';
import styles from './expertise-attachment.module.css';
import { Dispatch } from '../../../../../node_modules/redux';
import { Document, Page } from 'react-pdf';
import { previewAttachment } from '../../../../store/details/expertise-attachment/actions';
import { getEnv } from '../../../../store/utils/env/env.manager';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { getDownloadLink } from '../../../../store/shared/actions';

const env = getEnv();
const baseURL = env.baseURL;

interface PropsFromState {
  readonly expertiseAttachments: ExpertiseAttachmentResponse[];
  readonly selectedAttachmentAmazonId: string;
}

interface PropsFromDispatch {
  readonly previewAttachment: typeof previewAttachment;
  readonly getDownloadLink: typeof getDownloadLink;
}

interface Props {
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & Props;

interface IState {
  numPages: number | null;
}

class ExpertiseAttachment extends React.Component<AllProps, IState> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.state = { numPages: null };
  }

  get attachments() {
    return this.props
      .expertiseAttachments
      .map((item, index) =>
        <AttachmentItem filename={item.filename}
          onClickPreview={this.previewClick}
          handleDownloadClick={this.props.handleDownloadClick}
          amazonKey={item.amazonKey}
          amazonId={item.amazonId}
          key={index} />);
  }

  get pages() {
    return Array.from(
      new Array(this.state.numPages),
      (el, index) => (
        <div key={`page_div${index + 1}`}>
          <Page
            pageNumber={index + 1}
            loading={this.localization.get('pdf.loading')}
          />
          {this.state.numPages && this.state.numPages > 1 && <div>
            <span className={styles.pageNumberingSpan}>{index + 1}</span>
          </div>}
        </div>
      ));
  }

  previewClick = (amazonKey: string) => {
    this.props.previewAttachment(amazonKey);
  }

  onDocumentLoadSuccess = (pdf: any) => {
    this.setState({ numPages: pdf.numPages as number });
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.attachments}>
          {this.props.selectedAttachmentAmazonId === '' ? this.attachments :
            <Document
              file={`${baseURL}/documents/download/${this.props.selectedAttachmentAmazonId}`}
              loading={this.localization.get('pdf.loading')}
              onLoadError={console.error}
              onLoadSuccess={this.onDocumentLoadSuccess}
            >
              {this.pages}
            </Document>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsExpertiseAttachment } }: ApplicationState): PropsFromState => ({
  expertiseAttachments: detailsExpertiseAttachment.expertiseAttachments,
  selectedAttachmentAmazonId: detailsExpertiseAttachment.selectedAttachmentAmazonId
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  previewAttachment: (amazonId: string) => dispatch(previewAttachment(amazonId)),
  getDownloadLink: (amazonKey: string, url: string, content: string, filename: string, onClickLink) => dispatch(getDownloadLink(amazonKey, url, content, filename, onClickLink))
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpertiseAttachment);
